import React from "react";
import {Colors, Container, Text} from "@bounce/shared/ui";
import {Button} from "../../ui/components";

const CHANGED_TEXT = "Priority order changed";

type Props = {
  onSave: () => void;
  onDiscard: () => void;
  disabled?: boolean;
};

export const ReorderChangesBar = ({onSave, onDiscard, disabled}: Props) => (
  <Container
    row
    fullWidth
    sx={{
      justifyContent: "space-between",
      alignItems: "center",
      px: 2.5,
      py: 1.5,
      mb: 2,
      borderRadius: "12px",
      backgroundColor: Colors.blue._100,
    }}
  >
    <Text size={13} variant="inter600" sx={{color: Colors.blue._800}}>
      {CHANGED_TEXT}
    </Text>
    <Container row sx={{gap: 1}}>
      <Button
        buttonType="outlined-primary"
        size="small"
        onClick={onDiscard}
        disabled={disabled}
        sx={{
          borderColor: Colors.blue._300,
          color: Colors.blue._800,
          "&:hover": {borderColor: Colors.blue._500, backgroundColor: Colors.blue._200},
        }}
      >
        Discard
      </Button>
      <Button buttonType="contained-primary" size="small" onClick={onSave} disabled={disabled}>
        Save order
      </Button>
    </Container>
  </Container>
);
